import firebase from 'firebase/compat/app'
import "firebase/compat/auth"
import "firebase/compat/database"
import 'firebase/compat/storage';
import 'firebase/compat/firestore';
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

var app = firebase.initializeApp({
  apiKey: "AIzaSyC2MUFaDarUs_fxMGYuWrnkyR072hbK3Tc",
  authDomain: "tritekorders.firebaseapp.com",
  projectId: "tritekorders",
  storageBucket: "tritekorders.firebasestorage.app",
  messagingSenderId: "538764189352",
  appId: "1:538764189352:web:317aba3dc52f07c0692c9d"
})
  export const storage = app.storage();

const auth = getAuth(app);
export const db = app.firestore();
export { auth };
